import { FC, memo } from 'react';
import type { CSSProperties, MouseEventHandler } from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { Skeleton } from '@mui/material';

import ArrowIcon from 'shared/ui/icons/general/ArrowIcon/ArrowIcon';
import { EXPANDER_NODE_ID } from 'constans/expander';
import { EXPANDER_BTN } from 'constans/testids';

import { MUI_ACCORDION_STYLES } from './constants';
import type { AccordionSummaryComponentProps } from './AccordionSummaryComponent.types';

const StyledMuiAccordionSummary = styled(MuiAccordionSummary)(({ theme: _ }) => MUI_ACCORDION_STYLES);

const AccordionSummaryComponent: FC<AccordionSummaryComponentProps> = ({
	isAuth,
	isLoading,
	onClick,
	showOpenLink,
	getOpenLinkButton,
	solo = false,
	language,
	classes,
	...accordionProps
}) => {
	const accordionWrapperinlineStyles = {
		display: 'flex',
		width: '100%',
		zIndex: 150,
		cursor: isLoading ? 'wait' : 'default',
	};
	const skeletonInlineStyles = { margin: '0 0 -18px 0' };
	const SVGInlineStyles = { pointerEvents: 'none' as CSSProperties['pointerEvents'] };

	const isExpandAllowed = isAuth && !isLoading;

	return (
		<div style={accordionWrapperinlineStyles}>
			<StyledMuiAccordionSummary
				tabIndex={-1}
				onClick={onClick}
				data-expand={EXPANDER_NODE_ID}
				expandIcon={
					!solo && (
						<div data-expand={EXPANDER_NODE_ID}>
							{isExpandAllowed ? (
								<span
									onClick={onClick}
									className={classes.expandIcon}
									data-testid={EXPANDER_BTN}
									data-expand={EXPANDER_NODE_ID}
								>
									<ArrowIcon
										style={SVGInlineStyles}
										data-expand={EXPANDER_NODE_ID}
										onClick={onClick as unknown as MouseEventHandler<SVGSVGElement>}
									/>
								</span>
							) : (
								<Skeleton width={32} height={52} variant="text" style={skeletonInlineStyles} />
							)}
						</div>
					)
				}
				{...accordionProps}
			/>
			{showOpenLink && getOpenLinkButton()}
		</div>
	);
};

export default memo(AccordionSummaryComponent);
